var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-status-badge',{attrs:{"design":"new","compact":_vm.compact,"tone":_vm.meta.tone,"label":_vm.meta.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }